const Funds = {
  tableConfig: {
    // showCheckbox: true,
    // tableStyle: 'min-width: 1250px;'
    // checkboxFilter: '{state}==0 && {complete}==1' // 成立 显示 checkbox
  },
  queryList: [
    {
      name: 'systemSerialNum',
      label: '系统流水号',
      component: 'input'
    },
    {
      name: 'name',
      label: '姓名',
      component: 'input'
    },
    {
      name: 'schoolName',
      label: '所属单位',
      component: 'input'
    },
    {
      name: 'mobile',
      label: '电话',
      component: 'input'
    },
    {
      name: 'bankName',
      label: '开户行',
      component: 'input'
    },
    {
      name: 'bankCard',
      label: '卡号',
      component: 'input'
    },
    {
      name: 'applyTimeRange',
      label: '提现申请日期',
      component: 'dateRange'
    }
  ],
  urlMap: {
    'select': {
      url: '/finance/payBillDetail/queryPageByFinance',
      data: {status: 3}
    },
    'reviewSelect': '/paper/paperBaseInfo/sendPaperByIds',
    'reviewAll': '/paper/paperBaseInfo/sendAllPaper',
    'delete': '/paper/paperBaseInfo/delete'
  },
  operList: [// 操作列表
    {
      name: 'chooseReview',
      label: '回执信息导入',
      show: true,
      action: {
        type: 'dialog',
        footerHide: true,
        addr: 'systemManage/uploadFunds'
      }
    },
    {
      name: 'download',
      label: '下载文件',
      show: true,
      action: {
        type: 'url',
        addr: '/static/demo/caiwu_demo.xls'
      }
    }
  ],
  titles: [
    {
      name: 'id',
      key: true
    },
    {
      name: 'systemSerialNum',
      label: '系统流水号'
    },
    {
      name: 'name',
      label: '收款人姓名'
    },
    {
      name: 'schoolName',
      label: '所属单位'
    },
    {
      name: 'mobile',
      label: '收款人联系电话'
    },
    {
      name: 'bankName',
      label: '开户行'
    },
    {
      name: 'bankCard',
      label: '卡号'
    },
    {
      name: 'money',
      label: '金额'
    },
    {
      name: 'applyTime',
      label: '提现申请时间'
    }
    // {
    //   name: 'operation',
    //   label: '操作',
    //   width: 120,
    //   actionList: [
    //     {
    //       label: '修改',
    //       name: 'update',
    //       kind: 'primary',
    //       type: 'dialog',
    //       width: 800,
    //       addr: 'thesisManage/thesisEdit?{id}'
    //     },
    //     {
    //       label: '删除',
    //       kind: 'primary',
    //       type: 'request',
    //       addr: 'delete',
    //       data: ['{id}'],
    //       confirm: {
    //         desc: '确认删除？'
    //       }
    //     }
    //   ]
    // }
  ]
}
export default Funds



// WEBPACK FOOTER //
// ./src/layout/regularPage/config/fundsManage/bankSlipImport.js